export const ordersEN = {
  'Open Pedigree': 'Open Pedigree',
  'Open Datasheet': 'Open Datasheet',
  'Re-Link Ambry': 'Re-Link Ambry',
  'Send Pedigree to Ambry': 'Send Pedigree to Ambry',
  'Open Test Results': 'Open Test Results',
  'Link Order to Patient': 'Link Order to Patient',
  'Documents Added by Ambry': 'Documents Added by Ambry',
  'There no documents to display': 'There no documents to display',
  'Client Uploaded Documents': 'Client Uploaded Documents',
  'Select Organization': 'Select Organization',
  "Organization's orders": "Organization's orders",
  'My Orders': 'My Orders',
  'All Organizations': 'All Organizations',
  'Failed to change organization': 'Failed to change organization',
  'Failed to load data': 'Failed to load data',
  'Pedigree has been successfully sent': 'Pedigree has been successfully sent',
  'Name': 'Name',
  'Date': 'Date',
  'View': 'View',
  'Open Status Results': 'Open Status Results',
  'Close': 'Close',
  'Documents for': 'Documents for',
  'Close': 'Close',
  'Cancel': 'Cancel',
  'Save': 'Save',
  'Operation Canceled': 'Operation Canceled',
  'Pedigree sent': 'Pedigree sent',
  "Organization's orders": "Organization's orders",
  'My Orders': 'My Orders',
};